<template lang="pug">
include Conocimientos.pug
</template>

<script type="text/javascript">
import { extend, isArray, isEmpty, filter } from 'underscore'
import Api from './services/Api'
import { mapState } from 'vuex'
import TrainerTitle from '@/components/trainer_title/TrainerTitle'

export default {
  name: "Conocimientos",
  components: {
    TrainerTitle,
  },
  computed: extend(mapState([
    "context", "token",
  ]), {
    hasAnyCourse() {
      const trainer = this.trainer
      const cecs = this.cecs
      const hasCecs = isArray(cecs) && !isEmpty(cecs)
      const hasCecsV2 = !isEmpty(this.getV2Cecs(trainer.courses_v2))
      return hasCecs || hasCecsV2
    }
  }),
  props: ["cecs", "trainer", "plan", "actionFormacion"],
  created() {
    if (/\/dashboard\//.test(window.location.href)) {
      this.editEnabled = true
    }
    this.currentToken = this.token
    this.currentUrl = window.location.href
  },
  data() {
    return {
      editEnabled: false,
      currentToken: null,
      currentUrl: null,
      course: {
        name: '',
        school: '',
        category: '',
        subcategory: '',
        course: '',
        courses: [],
      },
    }
  },
  methods: {
    getV2Cecs(courses) {
      return filter(courses, course => {
        return (!course.level)
      })
    }
  },
  watch: {
    'course.category': async function(newValue, oldValue) {
      const response = await Api.getSubcategories(newValue)
      const data = response.data
      const items = data.items
      this.course.courses = items
    },
  },
}
</script>

<style scoped lang="scss">
@import '../variables';
@import '../variables_colreps';
@import '../variables_mexreps';

@import 'TrainerView';

.context-colreps {
  @import 'TrainerViewColreps';
}

.context-mexreps {
  @import 'TrainerViewMexreps';
}
</style>



// WEBPACK FOOTER //
// src/components/Conocimientos.vue